export default "__VITE_ASSET__FOv_roSj__"